export const CAROUSEL_ITEM_WIDTH_MAP = {
  small: {
    xs: 90,
    sm: 50,
    md: 50,
    lg: 33.33,
    xl: 33.33,
    xxl: 25,
    xxxl: 25
  },
  large: {
    xs: 60,
    sm: 75,
    md: 75,
    lg: 75,
    xl: 75,
    xxl: 75,
    xxxl: 75
  }
};